import React from "react";
import Button from "components/button";
import { InputField } from "components/fields";
import { formatDate, formatDateTime } from "utils/format";

export const formatAnswer = (answer) =>
  typeof answer === "boolean" ? (answer ? "Yes" : "No") : String(answer);

/**
 * One weekly check-in: its answers, the leader notes on it and a composer for
 * adding a note. Used in the org chart drawer and on the member profile.
 */
const SubmissionCard = ({
  submission,
  draft,
  onDraftChange,
  onAddNote,
  saving,
  columns = 1,
  titleAs: Title = "h3",
}) => {
  const canSave = !saving && Boolean((draft || "").trim());

  return (
    <article className="rounded-control border border-line p-4">
      <header className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
        <Title className="text-sm font-semibold text-fg">Week of {formatDate(submission.weekStart)}</Title>
        {submission.submittedAt && (
          <p className="text-xs text-fg-muted">Submitted {formatDateTime(submission.submittedAt)}</p>
        )}
      </header>

      <dl className={`mt-3 grid grid-cols-1 gap-3 ${columns === 2 ? "md:grid-cols-2" : ""}`}>
        {(submission.answers || []).map((a, i) => (
          <div key={i}>
            <dt className="text-xs text-fg-muted">
              {a.prompt}
              {a.leaderName ? <span> · asked by {a.leaderName}</span> : null}
            </dt>
            <dd className="mt-0.5 text-sm font-medium text-fg">{formatAnswer(a.answer)}</dd>
          </div>
        ))}
      </dl>

      {(submission.notes || []).length > 0 && (
        <div className="mt-3 flex flex-col gap-1.5 border-t border-line pt-3">
          <p className="text-caption">Notes</p>
          {submission.notes.map((n) => (
            <div key={n.id} className="rounded-control bg-surface-raised px-3 py-2">
              <p className="text-sm text-fg">{n.text}</p>
              <p className="mt-0.5 text-xs text-fg-muted">
                {n.byName} · {formatDateTime(n.at)}
              </p>
            </div>
          ))}
        </div>
      )}

      <form
        className="mt-3 flex items-start gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          if (canSave) onAddNote();
        }}
      >
        <InputField
          aria-label={`Note on the week of ${formatDate(submission.weekStart)}`}
          value={draft || ""}
          onChange={(e) => onDraftChange(e.target.value)}
          placeholder="Add a note…"
          className="min-w-0 flex-1"
        />
        <Button type="submit" variant="secondary" loading={saving} disabled={!canSave}>
          Add Note
        </Button>
      </form>
    </article>
  );
};

export default SubmissionCard;
